import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { fetchInvitationRequestsList } from '@libs/api/invitationRequests';
import { InvitationRequestListItem } from '@libs/models/invitationRequests';
import { activateAgency, deactivateAgency } from '@libs/api/agencies';
import { activateFacility, deactivateFacility } from '@libs/api/facilities';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  requests: InvitationRequestListItem[];
  page: number;
  perPage: number;
  total: number;
  loadRequests: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
  activateEntity: (entity: InvitationRequestListItem) => Promise<void>;
  deactivateEntity: (entity: InvitationRequestListItem) => Promise<void>;
};

export const useClientRequestsListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  requests: [],
  page: 1,
  perPage: 50,
  total: 0,

  loadRequests: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchInvitationRequestsList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        requests: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false, initialized: true });
    }
  },
  activateEntity: async (entity: InvitationRequestListItem) => {
    if (entity.orgType === 'agency') {
      const resp = await activateAgency(entity.id);
    }
    if (entity.orgType === 'facility') {
      const resp = await activateFacility(entity.id);
    }
  },
  deactivateEntity: async (entity: InvitationRequestListItem) => {
    if (entity.orgType === 'agency') {
      const resp = await deactivateAgency(entity.id);
    }
    if (entity.orgType === 'facility') {
      const resp = await deactivateFacility(entity.id);
    }
  },
}));
